(function () {
  if (window.__lenisShopifyInit) return;
  window.__lenisShopifyInit = true;

  var DEFAULTS = {
    duration: 1.1,
    smoothWheel: true,
    touchMultiplier: 1.4,
    wheelMultiplier: 1
  };

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function startLenis() {
    if (!window.Lenis || prefersReducedMotion()) return;

    var lenis = new window.Lenis(DEFAULTS);
    window.__lenisInstance = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }

  function loadLenisScript() {
    if (window.Lenis) {
      startLenis();
      return;
    }

    var existing = document.querySelector('script[data-lenis-cdn="true"]');
    if (existing) {
      existing.addEventListener("load", startLenis, { once: true });
      return;
    }

    var script = document.createElement("script");
    script.src = "https://unpkg.com/lenis@1.3.13/dist/lenis.min.js";
    script.defer = true;
    script.dataset.lenisCdn = "true";
    script.onload = startLenis;
    document.head.appendChild(script);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadLenisScript, { once: true });
  } else {
    loadLenisScript();
  }
})();